import React from 'react';
import ContactUs from './ContactUs';
import AboutUs from './AboutUs';
import banner from './banner.png'
import leftImg from './img1.jpg'

import rightImg from './img2.jpg'

const Home = () => {

    //let banner = 'https://images.pexels.com/photos/17626465/pexels-photo-17626465/free-photo-of-comida-acera-frutas-tienda.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
    //let rightImg='https://media.istockphoto.com/id/1489114602/es/foto/verdulera-trabajando-en-el-mercado-sosteniendo-una-caja-que-contiene-frutas-y-verduras-frescas.jpg?b=1&s=612x612&w=0&k=20&c=aT8cFNmtYRvJG71EEFP_u9SFAQ0IyVtuBBqXYwRi4K4='
   // let leftImg ='https://images.pexels.com/photos/262967/pexels-photo-262967.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1'
    let leftText=`Somos expertos en frescura y calidad, con más de 40 años de experiencia seleccionando los mejores productos para nuestros clientes. Nuestro compromiso es ofrecerte productos frescos, de alta calidad y a precios competitivos.`
    let rightText=`Diariamente recorremos cada rincón del Mercado Central, seleccionando con cuidado las frutas y verduras de productores nacionales e internacionales para brindarte una gran variedad con la mejor calidad, al mejor precio.`
        
    return (
        <>
        <AboutUs banner={banner}  rightImg={rightImg} leftImg={leftImg} leftText={leftText} rightText={rightText}></AboutUs>
        <ContactUs></ContactUs>
        </>
    );
};

export default Home;